export default {
	title: 'Mi perfil',
	messages: {
		choose_plan: 'Elegir un plan',
		unlock_immediately:
			'Desbloquear inmediatamente todas las funcionalidades',
		current_subscription: 'Tu suscripción actual'
	},
	language: {
		title: 'Idioma',
		description: 'Elige el idioma de la interfaz',
		languages: {
			de: 'Alemán',
			en: 'Inglés',
			es: 'Español',
			fr: 'Francés',
			hi: 'Hindi',
			it: 'Italiano',
			ja: 'Japonés',
			pt: 'Portugués',
			zh: 'Chino (mandarín)'
		}
	},
	theme: {
		title: 'Selección de tema'
	},
	actions: {
		manage_subscription: 'Gestionar mi suscripción'
	},
	api_access: {
	  title: "Acceso API (servidor MCP)",
	  description: "Permite a los agentes de IA (Claude, ChatGPT, etc.) acceder a tus proyectos Gerositus mediante el Model Context Protocol. El token otorga el mismo acceso que el tuyo — mantenlo en secreto.",
	  endpoint: "URL del endpoint MCP",
	  no_token: "Aún no hay token — genera uno para habilitar el acceso de agentes de IA.",
	  default_token_name: "Token por defecto",
	  status_active: "Activo",
	  status_revoked: "Revocado",
	  created_at: "Creado el {{date}}",
	  last_used_at: "Último uso el {{date}}",
	  never_used: "Aún no utilizado",
	  generate: "Generar token",
	  regenerate: "Renovar token",
	  revoke: "Revocar token",
	  copy: "Copiar",
	  copied: "Copiado al portapapeles",
	  copy_failed: "Error al copiar",
	  config_example: "Ejemplo de configuración de cliente MCP",
	  reveal_title: "Guarda tu token ahora",
	  reveal_done: "Lo he guardado",
	  reveal_warning_title: "Esta es la única vez que verás este token",
	  reveal_warning_body: "Cópialo en un lugar seguro (gestor de contraseñas). Si lo pierdes, deberás renovarlo. Cualquiera con este token puede leer tus proyectos.",
	  regenerate_confirm_title: "¿Renovar el token de acceso?",
	  regenerate_confirm_body: "El token actual se revocará de inmediato y se emitirá uno nuevo. Cualquier agente de IA que use el token anterior deberá reconfigurarse.",
	  revoke_confirm_title: "¿Revocar el token de acceso?",
	  revoke_confirm_body: "Cualquier agente de IA con este token perderá el acceso. Podrás generar uno nuevo cuando quieras."
	}
};
